
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"invalid-classification":"Die Attributbeziehungen wurden geändert. Dadurch ist die bisherige Klassifikation ungültig geworden.","invalid-classification.title":"Die Klassifikation ist ungültig."},"en":{"invalid-classification":"The attribute relations have been changed. As a result, the previous classification has become invalid.","invalid-classification.title":"The classification is invalid."}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();